import CoinPullReportPrintComponent from './coin_pull_report_print.component';

let CoinPullReportPrintModule = angular.module('CoinPullReportPrint', [
])
.config(($stateProvider, $urlRouterProvider) => {
	"ngInject";

	$urlRouterProvider.otherwise('/coin-pull-report');

	$stateProvider
	.state('coinPullReportPrint', {
		url: '/coin-pull-report-print?route&date&branch',
		component: 'coinPullReportPrint',
		data: {
			requireLogin: true
		},
	});
})

.component('coinPullReportPrint', CoinPullReportPrintComponent)

.name;

export default CoinPullReportPrintModule;


// WEBPACK FOOTER //
// ./client/app/components/coin_pull_report/print_route_coin/index.js